import React, { useMemo } from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";

import LoadTable from "../../../generic/loadTable";

const ClientTable = ({ clients }) => {
  const keyClients = useMemo(
    () => clients.map((c, i) => ({ ...c, key: i })),
    [clients]
  );

  const columns = useMemo(
    () => [
      {
        key: "name",
        title: (
          <FormattedMessage
            id="clientUser.client.name"
            defaultMessage="Název"
          />
        ),
        dataIndex: "name",
      },
      {
        key: "companyId",
        title: (
          <FormattedMessage
            id="clientUser.client.companyId"
            defaultMessage="IČO"
          />
        ),
        dataIndex: "companyId",
      },
      {
        key: "account",
        title: (
          <FormattedMessage
            id="clientUser.client.account"
            defaultMessage="z-account"
          />
        ),
        dataIndex: "code",
      },
      {
        key: "evoCode",
        title: (
          <FormattedMessage
            id="clientUser.client.evoCode"
            defaultMessage="EVO kód"
          />
        ),
        dataIndex: "evoCode",
      },
    ],
    []
  );

  return (
    <Row>
      <Col>
        <LoadTable
          columns={columns}
          values={keyClients}
          className="no-pointer"
          emptyText={
            <FormattedMessage
              id="user.noUsers"
              defaultMessage="tento klient nemá žádné uživatele"
            />
          }
        />
      </Col>
    </Row>
  );
};

export default ClientTable;
